import React from "react";
import PopupWrapper from "../../components/PopupWrapper";

const ChildActionModal = ({ 
  isOpen, 
  onClose, 
  child, 
  onAddFunds, 
  onSubtractFunds 
}) => {
  if (!child) return null;

  return (
    <PopupWrapper 
      isOpen={isOpen} 
      onClose={onClose}
      isSmall={true}
    >
      <div className="d-flex flex-column align-items-center">
        <h5 className="mb-4 text-center">
          What would you like to do for <strong>{child.FirstName}</strong>?
        </h5>
        
        <div className="d-flex justify-content-center gap-3 mb-3 w-100">
          <button
            className="confirm-btn p-2 flex-grow-1"
            onClick={() => {
              onAddFunds(child);
              onClose();
            }}
          >
            Add Funds
          </button>
          
          <button
            className="cancel-btn p-2 flex-grow-1"
            onClick={() => {
              onSubtractFunds(child);
              onClose();
            }}
          >
            Subtract Funds
          </button>   
        </div>

        <button
          className="editing-btn mt-2 p-2"
          onClick={onClose}
        >
          Cancel
        </button>
      </div>
    </PopupWrapper>
  );
};

export default ChildActionModal;